<template>
<Modal
    v-model="isVisible"
    title="Benachrichtigungen"
>
    Möchtest du Push-Benachrichtigungen für alles Wichtige bekommen? Z.B. neue Dienste, Einatzort- oder Zeitwechsel.
    <br><br>
    <ion-button
        @click="onClickDeny"
        expand="block"
        color="transparent"
    >
        Nein (nicht empfohlen)
    </ion-button>
    <ion-button
        @click="onClickAllow"
        expand="block"
        color="primary"
    >
        Ja
    </ion-button>
</Modal>
</template>

<script setup lang="ts">
import { IonButton } from '@ionic/vue'
import Modal from './Modal.vue';
import { useAuthStore } from '@/store/auth';
import { registerToPushNotifications } from '@/helper/pushNotifications'
import {deviceProfileRefresh} from "@/helper/deviceProfile";
import { watch, ref } from 'vue';

const authStore = useAuthStore()
const isVisible = ref(false)

const onClickDeny = () => {
    authStore.didRequestForPushNotificationsPermission = true
    authStore.needsPromptForPushNotificationsPermission = false
}

const onClickAllow = async () => {
    authStore.didRequestForPushNotificationsPermission = true
    authStore.needsPromptForPushNotificationsPermission = false

    const success = await registerToPushNotifications()

    // no await because not needed
    if (success) {
        deviceProfileRefresh(true)
    }
}

watch(() => authStore.needsPromptForPushNotificationsPermission, value => isVisible.value = value)
</script>
